<template lang="pug">
div
  .text-sm.font-semibold.my-6 PRESCRIPTION LETTER
  .text-left.my-6
    .text-xs Name :&nbsp;
      span.neutral500--text {{ patientName }}&nbsp;
    .text-xs(v-if="nric") NRIC :&nbsp;
      span.neutral500--text {{ nric }}
    .mb-2
    div.mb-2(v-for="(medication, medicationIdx) in medications" :key="medicationIdx")
      .text-xs.font-semibold.underline Medication {{ medicationIdx + 1 }}
      .ml-2
        .text-xs
          span.font-semibold Name :&nbsp;
          span.font-normal.neutral500--text {{ medication.name }}
        .text-xs
          span.font-semibold Dosage :&nbsp;
          span.font-normal.neutral500--text {{ medication.dosage_value }} {{ medication.dosage_unit }}
        .text-xs
          span.font-semibold Frequency :&nbsp;
          span.font-normal.neutral500--text {{ medication.frequency }}
        .text-xs
          span.font-semibold Instruction :&nbsp;
          span.font-normal.neutral500--text {{ medication.instruction }}
        .text-xs
          span.font-semibold Duration :&nbsp;
          span.font-normal.neutral500--text {{ medication.duration }}
        .text-xs
          span.font-semibold Indication :&nbsp;
          span.font-normal.neutral500--text {{ medication.indication }}

    .text-xs.mb-6 Sincerely,

    .text-xs ___________________
    .text-xs.neutral500--text {{ doctorName }}
    .text-xs.neutral500--text {{ date }}


</template>

<script>
export default {
  props: {
    prescriptionLetterData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    date () {
      if (this.prescriptionLetterData?.date) {
        return this.$options.filters.convertToDateOnly(this.prescriptionLetterData.date)
      }
      return '{Date}'
    },
    doctorName () {
      return this.prescriptionLetterData?.doctor_name || '{Doctor name}'
    },
    patientName () {
      return this.prescriptionLetterData?.name || '{Patient name}'
    },
    nric () {
      return this.prescriptionLetterData?.ic || '{NRIC}'
    },
    medications () {
      if (this.prescriptionLetterData?.medications) {
        if (this.prescriptionLetterData.medications.length > 0) {
          return this.prescriptionLetterData.medications
        }

        return []
      }

      return [
        {
          name: '{Drug name 1}',
          dosage_value: '{Dosage 1}',
          instruction: '{Instruction 1}',
          duration: '{Duration 1}',
          frequency: '{Frequency 1}',
          indication: '{Indication 1}'
        },
        {
          name: '{Drug name 2}',
          dosage_value: '{Dosage 2}',
          instruction: '{Instruction 2}',
          duration: '{Duration 2}',
          frequency: '{Frequency 2}',
          indication: '{Indication 2}'
        }
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  line-height: 25px !important;
}
.underline-content {
  border-bottom: 1px solid var(--v-neutral700);
}
</style>